import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdc5cfe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "showcase" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Showcase", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "headline" }, "See how your website can look like", -1))
const _hoisted_4 = ["src"]

import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide } from 'vue3-carousel'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowcaseSection',
  setup(__props) {

const carouselSettings = {
  itemsToShow: 1.2,
  snapAlign: 'center',
  autoplay: true,
  wrapAround: true,
  transition: 3000
}

const carouselBreakpoints = {
  // 700px and up
  700: {
    itemsToShow: 4,
    snapAlign: 'center',
  },
}

const carouselItems = [
  {image: require('@/assets/screenshot_header.png')},
  {image: require('@/assets/screenshot_carousel_02.png')},
  {image: require('@/assets/screenshot_carousel_03.png')},
  {image: require('@/assets/screenshot_carousel_04.png')},
  {image: require('@/assets/screenshot_carousel_05.png')},
  {image: require('@/assets/screenshot_carousel_06.png')},
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_unref(Carousel), {
      breakpoints: carouselBreakpoints,
      settings: carouselSettings
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(carouselItems, (item, index) => {
          return _createVNode(_unref(Slide), { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: item.image
              }, null, 8, _hoisted_4)
            ]),
            _: 2
          }, 1024)
        }), 64))
      ]),
      _: 1
    })
  ]))
}
}

})